/**
 * NEON COACH - ???? ??????? ??????? (Sound Feedback Service)
 * ???? ??????? ?????? ???? ?????? ???????? (Taskmaster Acknowledgement Beep) ???:
 * 1. ??? ??????? ?????? (Voice Session Start / ??? ??????)
 * 2. ???? ????? ???? ????? ????? (Successful Write/Mutation Action)
 *
 * ?????? Web Audio API ?? AudioBuffer ???? ?????? (Preloaded) ?????? ?? ??????
 * ?????? ????? ????? ?? ??????? (Debounce / Duplicate Guard) ???? ????? ??????? (Concurrency Control)?
 * ?? ???? ??? (HTMLAudioElement Fallback) ??? ??????? ??? ??? ?????????? ??????? ?? ??? ???? ?? ???.
 */

export const NEON_ACK_SOUND_URL = '/neon-ack.wav';

export const NEON_SOUND_CONFIG = {
  url: NEON_ACK_SOUND_URL,
  defaultVolume: 0.7, // ????? ????? ????? (0.6 - 0.8)
  minIntervalMs: 320  // ????? ?? ??????? ???? Spam ??????
};

export class NeonSoundService {
  constructor() {
    this.audioCtx = null;
    this.audioBuffer = null;
    this.preloadPromise = null;
    this.currentSource = null;
    this.lastPlayTime = 0;
    this.volume = NEON_SOUND_CONFIG.defaultVolume;
  }

  /**
   * ????? ?????? Web Audio Context ?? ??? ????? ?? ???????? (User Gesture)
   * ?????? ???? Autoplay ?? ??????? iOS Safari ? Android Chrome
   */
  async initializeAudio() {
    if (typeof window === 'undefined') return;

    try {
      const AudioCtxClass = window.AudioContext || window.webkitAudioContext;
      if (AudioCtxClass && !this.audioCtx) {
        this.audioCtx = new AudioCtxClass();
      }

      if (this.audioCtx && this.audioCtx.state === 'suspended') {
        await this.audioCtx.resume();
      }

      // ??? ??????? ?????? ?? ??????? ???? ???
      this.preloadSounds().catch(() => {});
    } catch (e) {
      console.warn('NeonSoundService init non-fatal warning:', e);
    }
  }

  init() {
    return this.initializeAudio();
  }

  /**
   * ????? ??? ????? ??? ?????? ??? AudioBuffer ??? ????? ???
   * ?????? ???????? ?????? ???? ?? ??????? ???? ?????
   */
  async preloadSounds() {
    if (this.audioBuffer) return this.audioBuffer;
    if (this.preloadPromise) return this.preloadPromise;

    this.preloadPromise = (async () => {
      try {
        const resp = await fetch(NEON_SOUND_CONFIG.url);
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const arrayBuf = await resp.arrayBuffer();

        const AudioCtxClass = typeof window !== 'undefined' ? (window.AudioContext || window.webkitAudioContext) : null;
        if (!this.audioCtx && AudioCtxClass) {
          this.audioCtx = new AudioCtxClass();
        }

        if (this.audioCtx) {
          // ??????? ???? ?? ??? ArrayBuffer ????? ??? ????? ?? ??????? ?????
          this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuf.slice(0));
          return this.audioBuffer;
        }
      } catch (err) {
        console.warn('NeonSoundService preload failed, fallback will be used:', err);
      } finally {
        this.preloadPromise = null;
      }
      return null;
    })();

    return this.preloadPromise;
  }

  /**
   * ????? ??? ??????? (Acknowledgement Beep)
   * ????:
   * 1. ??? ??????? ?????? (Debounce)
   * 2. ??? ????? ??????? (????? ????? ?????? ?? ???)
   * 3. ??????? ????? ?? HTMLAudioElement ?? ??? ???? Web Audio
   * 4. ??? ??? ?? ????? ?????????? ??? ???
   */
  async playAcknowledgement(options = {}) {
    const now = Date.now();
    // 1. ??? ????? ??????? (Debounce / Duplicate Guard)
    if (now - this.lastPlayTime < NEON_SOUND_CONFIG.minIntervalMs) {
      return false;
    }
    this.lastPlayTime = now;

    const playVolume = typeof options.volume === 'number' ? options.volume : this.volume;

    // 2. ?????? ??????? ??? Web Audio API
    try {
      if (!this.audioCtx && typeof window !== 'undefined') {
        const AudioCtxClass = window.AudioContext || window.webkitAudioContext;
        if (AudioCtxClass) this.audioCtx = new AudioCtxClass();
      }

      if (this.audioCtx && this.audioCtx.state === 'suspended') {
        await this.audioCtx.resume();
      }

      if (!this.audioBuffer) {
        await this.preloadSounds();
      }

      if (this.audioCtx && this.audioBuffer) {
        // ????? ???????: ????? ????? ?????? ???? ??????? ??????
        if (this.currentSource) {
          try {
            this.currentSource.stop();
            this.currentSource.disconnect();
          } catch (_) {}
          this.currentSource = null;
        }

        const source = this.audioCtx.createBufferSource();
        source.buffer = this.audioBuffer;

        const gainNode = this.audioCtx.createGain();
        gainNode.gain.setValueAtTime(playVolume, this.audioCtx.currentTime);

        source.connect(gainNode);
        gainNode.connect(this.audioCtx.destination);

        this.currentSource = source;
        source.onended = () => {
          if (this.currentSource === source) {
            this.currentSource = null;
          }
        };

        source.start(0);
        return true;
      }
    } catch (webAudioErr) {
      console.warn('Web Audio playback failed, trying HTMLAudioElement fallback:', webAudioErr);
    }

    // 3. ???? ?????? ????????? (HTMLAudioElement Fallback)
    try {
      if (typeof window !== 'undefined' && typeof Audio !== 'undefined') {
        const audio = new Audio(NEON_SOUND_CONFIG.url);
        audio.volume = playVolume;
        await audio.play();
        return true;
      }
    } catch (fallbackErr) {
      console.warn('Sound playback failed (non-fatal):', fallbackErr);
    }

    return false;
  }

  playAck(options) {
    return this.playAcknowledgement(options);
  }

  setVolume(vol) {
    if (typeof vol === 'number' && vol >= 0 && vol <= 1) {
      this.volume = vol;
    }
  }

  getVolume() {
    return this.volume;
  }

  stop() {
    if (this.currentSource) {
      try {
        this.currentSource.stop();
        this.currentSource.disconnect();
      } catch (_) {}
      this.currentSource = null;
    }
  }
}

export const neonSoundService = new NeonSoundService();
